export function resolveAttendanceDoctorName(
  doctorId: string,
  doctorNames: Record<string, string>,
  ...fallbackNames: Array<string | null | undefined>
): string {
  const verifiedProfileName = String(doctorNames[doctorId] || '').trim();
  if (verifiedProfileName) return verifiedProfileName;

  return fallbackNames
    .map((name) => String(name || '').trim())
    .find(Boolean) || '';
}
